import { render, staticRenderFns } from "./MiniQuestion.vue?vue&type=template&id=e7a4d40a&"
import script from "./MiniQuestion.vue?vue&type=script&lang=js&"
export * from "./MiniQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports